/**
 * Brand logo — inlined SVG with fill="currentColor" so it picks up text color.
 * Per react-brand skill: 28×32px, scale between 20–40px wide.
 */
export function Logo({ className = "" }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="32"
      viewBox="0 0 28 32"
      fill="currentColor"
      className={className}
      aria-label="ServisSearch logo"
    >
      <path d="M12.458 14.067a1.294 1.294 0 1 1-2.587.015 1.294 1.294 0 0 1 2.587-.015M18.155 14.067a1.294 1.294 0 1 1-2.588.015 1.294 1.294 0 0 1 2.588-.015" />
      <path d="M14.011 5.508A10.3 10.3 0 0 0 3.71 15.811v6.765A5.724 5.724 0 0 0 9.433 28.3h9.184a5.723 5.723 0 0 0 5.723-5.724v-6.758a10.304 10.304 0 0 0-10.329-10.31m0 14.725a9.2 9.2 0 0 1-3.796-.797c-.512-.233-2.976 1.72-3.396 1.404-.305-.233 1.412-2.724 1.167-2.995a4.48 4.48 0 0 1-1.244-3.026c0-2.992 3.255-5.415 7.27-5.415s7.268 2.423 7.268 5.415-3.266 5.414-7.269 5.414M12.898 3.158a.69.69 0 0 1 .26.534v1.145a.09.09 0 0 0 .095.087q.376-.027.763-.026c.256 0 .508 0 .764.026a.09.09 0 0 0 .095-.087V3.692a.67.67 0 0 1 .252-.527 1.777 1.777 0 1 0-2.225 0zM9.559 28.994a4.804 4.804 0 0 0 8.91 0zM3.1 17.677a1.11 1.11 0 1 0-2.221 0v7.025a1.11 1.11 0 0 0 2.22 0zM27.147 17.677a1.11 1.11 0 1 0-2.221 0v7.025a1.11 1.11 0 0 0 2.22 0z" />
    </svg>
  );
}
